import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { catchError, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
    const router = inject(Router);
    const auth = inject(AuthService);

    return auth.isAuthenticated.pipe(
        map((isAuthenticated: boolean) => {
            if (isAuthenticated) {
                return true;
            }
            router.navigate(['/login'], { queryParams: {returnUrl: state.url} });
            auth.removeStorage();
            return false;
        }), catchError(() => {
            router.navigate(['/login']);
            auth.removeStorage();
            return of(false);
        }),
    );
};

